var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCookiepopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "303px",
    viewBox: "0 0 300 303",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cookie popup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4,0 L228.799615,0 L276,0 C278.209139,-4.05812251e-16 280,1.790861 280,4 L280,279 C280,281.209139 278.209139,283 276,283 L4,283 C1.790861,283 2.705415e-16,281.209139 0,279 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.8%",
    y: "-4.8%",
    width: "111.8%",
    height: "111.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-13--Actions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.11--Cookie-popup-customization",
    transform: "translate(-1003.000000, -385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(149.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cookie-popup",
    transform: "translate(861.000000, 246.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Close-button",
    transform: "translate(260.000000, 8.000000)",
    fill: "#969696",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "times"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.40863871,5.99914736 L11.7044873,1.7126801 C12.0962309,1.32088084 12.0962309,0.685648715 11.7044873,0.293849449 C11.3127437,-0.0979498165 10.6776018,-0.0979498165 10.2858582,0.293849449 L6,4.59030847 L1.7141418,0.293849449 C1.3223982,-0.0979498065 0.687256347,-0.0979498018 0.295512755,0.29384946 C-0.0962308371,0.685648722 -0.0962308418,1.32088083 0.295512745,1.7126801 L4.59136129,5.99914736 L0.295512745,10.2856146 C0.106382866,10.4732266 0,10.728612 0,10.9950299 C0,11.2614479 0.106382866,11.5168333 0.295512745,11.7044453 C0.483098064,11.893602 0.738447162,12 1.00482727,12 C1.27120738,12 1.52655648,11.893602 1.7141418,11.7044453 L6,7.40798624 L10.2858582,11.7044453 C10.4734435,11.893602 10.7287926,12 10.9951727,12 C11.2615528,12 11.5169019,11.893602 11.7044873,11.7044453 C11.8936171,11.5168333 12,11.2614479 12,10.9950299 C12,10.728612 11.8936171,10.4732266 11.7044873,10.2856146 L7.40863871,5.99914736 Z",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "text",
    fontFamily: "Helvetica",
    fontSize: 12,
    fontWeight: "normal",
    fill: "#7450C8"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 41.4902344,
    y: 266
  }, "Get your "), /*#__PURE__*/React.createElement("tspan", {
    x: 39.4804688,
    y: 280
  }, "LegalSite")), /*#__PURE__*/React.createElement("text", {
    id: "Text",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 90,
    fill: "#969696"
  }, "This website uses cookies. Click on the "), /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 107,
    fill: "#969696"
  }, "button bellow to consent to all cookies "), /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 124,
    fill: "#969696"
  }, "in accordance with our "), /*#__PURE__*/React.createElement("tspan", {
    x: 159.964844,
    y: 124,
    fill: "#7450C8"
  }, "Privacy Policy"), /*#__PURE__*/React.createElement("tspan", {
    x: 247.095703,
    y: 124,
    fill: "#969696"
  }, " or "), /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 141,
    fill: "#969696"
  }, "customize your preferences at any time "), /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 158,
    fill: "#969696"
  }, "on our legal page.")), /*#__PURE__*/React.createElement("g", {
    id: "Login-button",
    transform: "translate(16.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Color",
    fill: "#7450C8",
    x: 0,
    y: 0,
    width: 96,
    height: 36,
    rx: 4
  }), /*#__PURE__*/React.createElement("text", {
    id: "Text",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal",
    "line-spacing": 26,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19.2665081,
    y: 19
  }, "ACCEPT")))), /*#__PURE__*/React.createElement("text", {
    id: "Text",
    fontFamily: "Helvetica",
    fontSize: 14,
    fontWeight: "normal",
    "line-spacing": 26,
    fill: "#7450C8"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 139.165527,
    y: 214
  }, "OPTION"), /*#__PURE__*/React.createElement("tspan", {
    x: 161.331055,
    y: 240
  }, "S")), /*#__PURE__*/React.createElement("text", {
    id: "Title",
    fontFamily: "Helvetica",
    fontSize: 22,
    fontWeight: "normal",
    "line-spacing": 28,
    letterSpacing: -0.1571429,
    fill: "#7450C8"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 45
  }, "Cookies preferences"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookiepopup);
export default __webpack_public_path__ + "static/media/Cookie popup.c71612559a198a9d2139c578222651c4.svg";
export { ForwardRef as ReactComponent };